import * as React from 'react'

import { Field } from 'embed/constants'
import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepbystepWrapper as Wrapper } from '../Wrapper'

import { LifeInsuranceApplicationProps } from '../container'

const styles = require('./styles.scss')

export interface Props {
  handleChangeAndContinue: (field: Field, value: string) => void
}

export const ApplicationStepGender: React.SFC<LifeInsuranceApplicationProps & Props> = (props) => {
  React.useEffect(() => {
    props.setIsBeforeRouterQuestions(true)
  }, [])

  return (
    <Wrapper {...props}>
      <StepTitle>What’s your gender?</StepTitle>
      <ApplicationField
        product={Product.LifeInsurance}
        field={Fields.Gender}
        onChange={props.handleChangeAndContinue.bind(null, Fields.Gender)}
        styles={styles.formRow}
      />
    </Wrapper>
  )
}
